import { http } from "../utils/http"
import {
  COMPANY_INVITATION_REQUEST_URL,
  GET_COMPANY_ACTIVE_SUBSCRIPTION_URL,
  GET_COMPANY_ACTIVE_USER_COUNT_URL,
  GET_COMPANY_INVOICES_URL,
  GET_UPDATE_DELETE_COMPANY_URL,
} from "../constants/api/endpoints"

export const getCompany = async (company_id: string | undefined, pageIndex?: number) => {
  let url = GET_UPDATE_DELETE_COMPANY_URL.replace(":id", `${company_id}`)
  pageIndex ? url += `?page=${pageIndex}` : url
  return http.get(url).then()
}

export const getCompanyActiveUsersCount = async (company_id: string | undefined, pageIndex?: number, params?: { month: string, second_month?: string }) => {
  let url = GET_COMPANY_ACTIVE_USER_COUNT_URL.replace(":id", `${company_id}`)
  pageIndex ? url += `?page=${pageIndex}` : url
  return http.get(url, { params }).then()
}

export const getCompanyActiveSubscription = async (company_id: string) => {
  let url = GET_COMPANY_ACTIVE_SUBSCRIPTION_URL.replace(":id", `${company_id}`)
  return http.get(url)
}

export const deleteCompany = async (company_id: string) => {
  let url = GET_UPDATE_DELETE_COMPANY_URL.replace(":id", `${company_id}`)
  return http.delete(url)
}

export const sendInvitationRequest = async <T>(id: string, data?: T) => {
  const url = COMPANY_INVITATION_REQUEST_URL.replace(":id", id)
  return http.post(url, data)
}

export const disableClient = async <T>(id: string) => {
  const url = GET_UPDATE_DELETE_COMPANY_URL.replace(":id", id)
  return http.patch(url, {is_active: false})
}

export const enableClient = async <T>(id: string) => {
  const url = GET_UPDATE_DELETE_COMPANY_URL.replace(":id", id)
  return http.patch(url, {is_active: true})
}

export const getCompanyInvoices = async <T>(id: string) => {
  const url = GET_COMPANY_INVOICES_URL.replace(":id", id)
  return http.get(url)
}